// eslint-disable-next-line import/prefer-default-export
export const getEquipmentCurrentHoursSnapshot = (equipment = {}) => {
  const {
    currentHours = 0,
    lastTask = {},
  } = equipment;

  const { startTime, endTime } = lastTask;
  if (!startTime || endTime) return currentHours;

  const elapsedMs = Date.now() - startTime;
  if (elapsedMs <= 0) return currentHours;

  return currentHours + elapsedMs;
};

export const decorateEquipment = (equipment = {}) => {
  const newEquipment = { ...equipment };

  const hours = newEquipment.hours ?? 0;
  const days = newEquipment.days ?? 0;
  const weeks = newEquipment.weeks ?? 0;
  const months = newEquipment.months ?? 0;

  const hourlyCost = newEquipment.hourlyCost ?? 0;
  const dailyCost = newEquipment.dailyCost ?? 0;
  const weeklyCost = newEquipment.weeklyCost ?? 0;
  const monthlyCost = newEquipment.monthlyCost ?? 0;
  
  const hourlyBillingRate = newEquipment.hourlyBillingRate ?? 0;
  const dailyBillingRate = newEquipment.dailyBillingRate ?? 0;
  const weeklyBillingRate = newEquipment.weeklyBillingRate ?? 0;
  const monthlyBillingRate = newEquipment.monthlyBillingRate ?? 0;

  const totalHourlyCost = hourlyCost * hours;
  const totalDailyCost = dailyCost * days;
  const totalWeeklyCost = weeklyCost * weeks;
  const totalMonthlyCost = monthlyCost * months;

  const totalHourlyBilling = hourlyBillingRate * hours;
  const totalDailyBilling = dailyBillingRate * days;
  const totalWeeklyBilling = weeklyBillingRate * weeks;
  const totalMonthlyBilling = monthlyBillingRate * months;

  return {
    ...newEquipment,
    totalHourlyCost,
    totalDailyCost,
    totalWeeklyCost,
    totalMonthlyCost,
    totalHourlyBilling,
    totalDailyBilling,
    totalWeeklyBilling,
    totalMonthlyBilling,
    totalCost: totalHourlyCost + totalDailyCost + totalWeeklyCost + totalMonthlyCost,
    totalBilling: totalHourlyBilling + totalDailyBilling + totalWeeklyBilling + totalMonthlyBilling,
  };
};
